export enum Cvss40SupplementalComponent {
    Safety = 'S',
    Automated = 'AU',
    Recovery = 'R',
    ValueDensity = 'V',
    VulnerabilityResponseEffort = 'RE',
    ProviderUrgency = 'U',
}

export type Cvss40SupplementalValues = Record<
    Cvss40SupplementalComponent,
    string
>;

export const Cvss40SupplementalComponents = Object.values(
    Cvss40SupplementalComponent,
);

export const Cvss40SupplementalComponentNames: Record<
    Cvss40SupplementalComponent,
    string
> = {
    [Cvss40SupplementalComponent.Safety]: 'Safety',
    [Cvss40SupplementalComponent.Automated]: 'Automatable',
    [Cvss40SupplementalComponent.Recovery]: 'Recovery',
    [Cvss40SupplementalComponent.ValueDensity]: 'Value Density',
    [Cvss40SupplementalComponent.VulnerabilityResponseEffort]:
        'Response Effort',
    [Cvss40SupplementalComponent.ProviderUrgency]: 'Provider Urgency',
};
